import React, { useState } from 'react';
import classnames from 'classnames';
import Modal from '../../../../../../common/components/modal';

const RegionPopup = ({ region, onCreate, onSave, onClose, onDelete }) => {
  const newRegion = !region?.id;
  const [ name, setName ] = useState(() => (region?.name || ''));
  const handleChangeName = (event) => {
    setName(event.target.value);
  };
  const handleSave = () => {
    if (newRegion) {
      onCreate(region, { name });
    } else {
      onSave(region, { name });
    }
  };

  const handleDelete = () => {
    onDelete(region);
  };

  return (
    <Modal
      modalSize="xs"
      modalClassName="dialog-select-backdrop"
      modalContentClass="-height-auto"
      onClose={ onClose }
      modal
    >
      <div className="modal_header">
        {
          !newRegion &&
          <span
            className="modal_close icon-link -no-text -gray"
            title="Close"
            onClick={ onClose }
          >
            <svg className="icon-link_icon icon -i-close"><use xlinkHref="#svg_i-close" /></svg>
            <span className="icon-link_text">Close</span>
          </span>
        }
        <h3 className="modal_title">{ newRegion ? "Add New Region" : "Edit Region" }</h3>
      </div>
      <div className="modal_body">
        <div className="form-group -lg">
          <label className="form-label">Region's Name</label>
          <input
            className="form-field -full-width-standalone"
            type="text"
            value={ name }
            onChange={ handleChangeName }
          />
        </div>
      </div>
      <div className="modal_footer -new-region-standalone">
        <button
          className="button -square -danger -outline -pull-left"
          onClick={ handleDelete }
        >
          <svg className="button_icon icon -i-trash-big">
            <use xlinkHref="#svg_i-trash-big" />
          </svg>
        </button>
        <div
          className={
            classnames(
              "button-group -sm -pull-right",
              { '-no-cancel': newRegion }
            )
          }
        >
          {
            !newRegion &&
            <button className="button -submit -outline" onClick={ onClose }>
              Cancel
            </button>
          }
          <button
            className="button -submit"
            disabled={ !name }
            onClick={ handleSave }
          >
            { newRegion ? "Add" : "Save" }
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RegionPopup;
